import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=6c051fdd&scoped=true&"
import script from "./Highlight.vue?vue&type=script&lang=js&"
export * from "./Highlight.vue?vue&type=script&lang=js&"
import style0 from "./Highlight.vue?vue&type=style&index=0&id=6c051fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c051fdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c051fdd', component.options)
    } else {
      api.reload('6c051fdd', component.options)
    }
    module.hot.accept("./Highlight.vue?vue&type=template&id=6c051fdd&scoped=true&", function () {
      api.rerender('6c051fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/ScreenEditor/ViewPort/EditorCanvas/Highlight.vue"
export default component.exports